import type { IEquipmentItem } from '@shared/types';

export const SMART_PLAYGROUND_ITEMS: IEquipmentItem[] = [
  {
    id: 'sp-01',
    categorySlug: 'smart-playground',
    number: '01',
    title: 'Брусья гнутые двойные',
    description:
      'Две пары параллельных брусьев разной высоты. Используются для отжиманий в упоре на руках и отжиманий с опорой на низкие перекладины.',
    photos: ['/equipment/smart-playground/01. Брусья гнутые двойные.webp'],
    videoUrl: 'https://rutube.ru/play/embed/626e421c5d95aa247f05b076de375bb0',
    videoTitle: 'Отжимания на высоких и низких брусьях',
    specs: [
      { label: 'Высота', value: '100 / 160 см' },
      { label: 'Ширина', value: '58 см' },
      { label: 'Диаметр трубы', value: '48 мм' },
      { label: 'Материал', value: 'Ст3, порошковое окрашивание' },
      { label: 'Макс. нагрузка', value: '200 кг' },
      { label: 'Гарантия', value: '5 лет' },
    ],
    exercises: [
      {
        title: 'Отжимания на брусьях',
        inVideo: true,
        start:
          'Возьмитесь за параллельные перекладины и выйдите в упор на прямых руках. Стопы не касаются покрытия, плечи опущены.',
        steps: [
          'Плавно согните руки, опуская корпус между перекладинами до удобной глубины.',
          'Разогните руки и вернитесь в упор без рывка.',
        ],
        tips: [
          'Не проваливайтесь в плечах и не раскачивайтесь.',
          'Уменьшите глубину, если теряете контроль движения.',
        ],
      },
      {
        title: 'Отжимания с опорой на низкие брусья',
        inVideo: true,
        start:
          'Встаньте лицом к низкой паре брусьев, возьмитесь за перекладины и отведите ноги назад. Корпус и ноги образуют прямую линию.',
        steps: [
          'Согните руки, приближая грудь к уровню перекладин.',
          'Выпрямите руки, сохраняя положение корпуса.',
        ],
        tips: ['Не прогибайтесь в пояснице.', 'Дышите свободно, выдыхайте при выпрямлении рук.'],
      },
    ],
    safetyNote:
      'Занимайтесь на сухих перекладинах. Входите в упор и сходите со снаряда без прыжков.',
  },
  {
    id: 'sp-02',
    categorySlug: 'smart-playground',
    number: '02',
    title: 'Зона воркаута и тренажёров',
    description:
      'Зона уличных тренировок с силовыми тренажёрами, турниками, брусьями, рукоходами и скамьями. На изображении показан общий состав и расположение оборудования для силовых и гимнастических упражнений.',
    photos: ['/equipment/smart-playground/02. Воркаут.webp'],
    composition: [
      {
        title: 'Жим ногами',
        itemId: 'sp-05',
        description:
          'Силовой тренажёр с сиденьем, спинкой и платформой для стоп. Используется для жимовых движений ногами с опорой корпуса.',
      },
      {
        title: 'Жим от груди',
        itemId: 'sp-06',
        description: 'Тренажёр с сиденьем и двумя рабочими рукоятями для жима руками вперёд.',
      },
      {
        title: 'Двойной треугольник',
        itemId: 'sp-03',
        description:
          'Перекладины разной высоты, соединённые в треугольные контуры. Высокие перекладины — для упражнений в висе, низкие — для упражнений в упоре.',
      },
      {
        title: 'Тройной каскад турников',
        itemId: 'sp-13',
        description:
          'Перекладины на разной высоте для подтягиваний, виса и отжиманий с опорой ног на покрытие.',
      },
      {
        title: 'Брусья гнутые двойные',
        itemId: 'sp-01',
        description:
          'Две пары параллельных брусьев с изогнутыми рукоятями для упражнений с собственным весом.',
      },
      {
        title: 'Двойные разноуровневые брусья',
        itemId: 'sp-04',
        description:
          'Параллельные перекладины на разной высоте. Используются для упражнений в упоре и отжиманий.',
      },
      {
        title: 'Трёхуровневый рукоход',
        itemId: 'sp-07',
        description:
          'Протяжённая конструкция с поперечными перекладинами для передвижения в висе с перехватами рук.',
      },
      {
        title: 'Рукоход «змейка», шведская стенка и турники',
        itemId: 'sp-08',
        description:
          'Общий снаряд с извилистым рукоходом, вертикальной лестницей и перекладинами для гимнастических упражнений.',
      },
      {
        title: 'Многофункциональный комплекс',
        itemId: 'sp-10',
        description:
          'В одном комплексе соединены перекладины, шведская стенка, гимнастические кольца и скамьи для упражнений на пресс.',
      },
      {
        title: 'Лавка с упорами',
        itemId: 'sp-09',
        description:
          'Низкая конструкция с несколькими упорами для кистей. Предназначена для отжиманий с различным положением рук.',
      },
      {
        title: 'Отдельные скамьи',
        itemId: 'sp-12',
        description:
          'Горизонтальные скамьи для отдыха между подходами и упражнений с опорой на край скамьи.',
      },
    ],
  },
  {
    id: 'sp-03',
    categorySlug: 'smart-playground',
    number: '03',
    title: 'Двойной треугольник',
    description:
      'Комплекс из перекладин разной высоты, соединяющих опоры по треугольному контуру. Высокие перекладины используются для подтягиваний, низкие — как опора для отжиманий.',
    photos: ['/equipment/smart-playground/03. Двойной треугольник.webp'],
    videoUrl: 'https://rutube.ru/play/embed/216613c38ea2a8e6b13faa676e877eb1',
    videoTitle: 'Подтягивания на высокой перекладине',
    specs: [
      { label: 'Габариты', value: '1 200 × 800 × 1 800 мм' },
      { label: 'Диаметр трубы', value: '60 мм' },
      { label: 'Материал', value: 'Ст3, порошковое окрашивание' },
      { label: 'Макс. нагрузка', value: '150 кг' },
      { label: 'Гарантия', value: '5 лет' },
    ],
    exercises: [
      {
        title: 'Подтягивание на высокой перекладине',
        inVideo: true,
        start:
          'Возьмитесь за высокую перекладину хватом сверху и примите вис на прямых руках. Оставьте ноги свободными, без опоры на соседние элементы.',
        steps: [
          'Подтянитесь без раскачивания до положения, в котором подбородок выше перекладины.',
          'Плавно опуститесь до выпрямления рук.',
        ],
        tips: ['Не тянитесь к перекладине подбородком: поднимайте весь корпус.'],
      },
      {
        title: 'Отжимания от низкой перекладины',
        start:
          'Упритесь ладонями в низкую перекладину и отведите стопы назад. Держите корпус и ноги на одной линии.',
        steps: [
          'Согните руки, приближая грудь к перекладине.',
          'Оттолкнитесь и вернитесь в исходное положение.',
        ],
        tips: ['Сохраняйте живот подтянутым и не опускайте таз.'],
      },
    ],
    safetyNote:
      'Перед началом убедитесь, что рядом никто не выполняет махи и не занимает соседнюю перекладину.',
  },
  {
    id: 'sp-04',
    categorySlug: 'smart-playground',
    number: '04',
    title: 'Двойные разноуровневые брусья',
    description:
      'Две пары параллельных перекладин на разной высоте. Предназначены для упражнений в упоре на руках; низкая пара также используется для отжиманий с опорой ног на покрытие.',
    photos: ['/equipment/smart-playground/04. Двойные разноуровневые брусья.webp'],
    videoUrl: 'https://rutube.ru/play/embed/7bdbc2c6222709a0e3e9813aaa6cb78d',
    videoTitle: 'Отжимания на брусьях',
    specs: [
      { label: 'Высота перекладин', value: '95 / 155 см' },
      { label: 'Ширина', value: '58 см' },
      { label: 'Диаметр перекладины', value: '48 мм' },
      { label: 'Материал', value: 'Ст3' },
      { label: 'Макс. нагрузка', value: '200 кг' },
      { label: 'Гарантия', value: '5 лет' },
    ],
    exercises: [
      {
        title: 'Отжимания на брусьях',
        inVideo: true,
        start:
          'Выберите подходящую пару перекладин и примите упор на прямых руках. Удерживайте плечи опущенными, ноги — без опоры на покрытие.',
        steps: [
          'Согните руки и плавно опустите корпус между перекладинами.',
          'Выпрямите руки и вернитесь в упор.',
        ],
        tips: [
          'Не разводите локти резко в стороны.',
          'Остановите опускание раньше, если плечи уходят вперёд и теряется устойчивость.',
        ],
      },
      {
        title: 'Отжимания от низких перекладин',
        start: 'Возьмитесь за низкие перекладины, отведите стопы назад и выпрямите корпус.',
        steps: [
          'Согните руки, опуская грудь к перекладинам.',
          'Плавно разогните руки, не меняя положения таза.',
        ],
        tips: ['Держите стопы устойчиво, без скольжения.'],
      },
    ],
    safetyNote:
      'Входите в упор с устойчивого положения. Подбор упражнений при ограниченной подвижности согласуйте с инструктором.',
  },
  {
    id: 'sp-05',
    categorySlug: 'smart-playground',
    number: '05',
    title: 'Жим ногами',
    description:
      'Рычажный тренажёр с сиденьем, спинкой и платформой для стоп. Упражнение выполняется сидя: платформа отжимается ногами, а спина и таз остаются на опоре.',
    photos: ['/equipment/smart-playground/05. Жим ногами.webp'],
    videoUrl: 'https://rutube.ru/play/embed/58532f0865bbba4909bb4b547eb5146c',
    videoTitle: 'Жим ногами сидя',
    specs: [
      { label: 'Угол наклона', value: '45°' },
      { label: 'Ход платформы', value: '350 мм' },
      { label: 'Диаметр трубы', value: '60 мм' },
      { label: 'Материал', value: 'Ст3, порошковое окрашивание' },
      { label: 'Макс. нагрузка', value: '200 кг' },
      { label: 'Гарантия', value: '5 лет' },
    ],
    exercises: [
      {
        title: 'Жим ногами сидя',
        inVideo: true,
        start:
          'Сядьте с опорой спины и таза, поставьте стопы на платформу примерно на ширине таза. Возьмитесь за неподвижные рукояти.',
        steps: [
          'Плавно выжмите платформу ногами, оставляя колени слегка согнутыми в конце движения.',
          'Медленно согните ноги и верните платформу, сохраняя спину и таз на опоре.',
        ],
        tips: [
          'Направляйте колени в сторону носков.',
          'Не отрывайте пятки от платформы и не задерживайте дыхание.',
        ],
      },
    ],
    safetyNote:
      'Первую настройку тренажёра и выбор нагрузки выполните с инструктором. Не допускайте людей к движущейся платформе.',
  },
  {
    id: 'sp-06',
    categorySlug: 'smart-playground',
    number: '06',
    title: 'Жим от груди',
    description:
      'Рычажный тренажёр для жима от груди из положения сидя. Сиденье и спинка поддерживают корпус, а две рабочие рукояти перемещаются усилием рук вперёд.',
    photos: ['/equipment/smart-playground/06. Жим от груди.webp'],
    videoUrl: 'https://rutube.ru/play/embed/26b115a3c7eab8e832f76f5b93f3a854',
    videoTitle: 'Жим от груди сидя',
    specs: [
      { label: 'Ход рукоятей', value: '400 мм' },
      { label: 'Высота сиденья', value: '480 мм' },
      { label: 'Материал', value: 'Ст3, труба 60 мм' },
      { label: 'Покрытие', value: 'Порошковое, антивандальное' },
      { label: 'Макс. нагрузка', value: '180 кг' },
      { label: 'Гарантия', value: '5 лет' },
    ],
    exercises: [
      {
        title: 'Жим от груди сидя',
        inVideo: true,
        start:
          'Сядьте с опорой спины на спинку, поставьте стопы на покрытие и возьмитесь за рукояти на уровне груди.',
        steps: [
          'Плавно выжмите рукояти вперёд до почти полного выпрямления рук.',
          'Медленно верните рукояти к груди, не бросая рычаги.',
        ],
        tips: ['Сохраняйте спину на опоре и не поднимайте плечи к ушам.', 'Выдыхайте при жиме.'],
      },
    ],
    safetyNote:
      'Не вставайте до полной остановки рычагов. Нагрузку перед первым занятием подберите с инструктором.',
  },
  {
    id: 'sp-07',
    categorySlug: 'smart-playground',
    number: '07',
    title: 'Классический трёхуровневый рукоход',
    description:
      'Горизонтальный рукоход с участками разной высоты и перекладинами на опорах. Используется для передвижения в висе с перехватами рук и подтягиваний на перекладине.',
    photos: ['/equipment/smart-playground/07. Классический трехуровневый рукоход.webp'],
    videoUrl: 'https://rutube.ru/play/embed/49563e0c091ec36be68716a923f0d4c7',
    videoTitle: 'Передвижение по рукоходу и подтягивания',
    specs: [
      { label: 'Длина пролёта', value: '3 600 мм' },
      { label: 'Количество перекладин', value: '8 шт.' },
      { label: 'Уровней высоты', value: '3' },
      { label: 'Диаметр перекладины', value: '34 мм' },
      { label: 'Высота от земли', value: '2 100–2 600 мм' },
      { label: 'Гарантия', value: '5 лет' },
    ],
    exercises: [
      {
        title: 'Передвижение по рукоходу',
        inVideo: true,
        start:
          'Выберите доступный по высоте участок, возьмитесь за первую перекладину обеими руками и примите вис.',
        steps: [
          'Перенесите одну руку на следующую перекладину.',
          'Продолжайте движение, поочерёдно перехватываясь руками и сдерживая раскачивание.',
          'Остановитесь перед сходом и плавно опуститесь на покрытие.',
        ],
        tips: ['Начните с нескольких перекладин, чтобы сохранить уверенный хват до конца прохода.'],
      },
      {
        title: 'Подтягивание на перекладине',
        inVideo: true,
        start: 'Возьмитесь за перекладину хватом сверху и примите вис на прямых руках.',
        steps: [
          'Подтянитесь, направляя локти вниз, до положения подбородка выше перекладины.',
          'Плавно разогните руки и вернитесь в вис.',
        ],
        tips: ['Не используйте рывки и махи ногами.'],
      },
    ],
    safetyNote:
      'Под рукоходом не должно быть людей и посторонних предметов. Не перепрыгивайте между участками разной высоты.',
  },
  {
    id: 'sp-08',
    categorySlug: 'smart-playground',
    number: '08',
    title: 'Комплекс: рукоход змейкой, шведская стенка, 5 турников',
    description:
      'Общий комплекс из рукохода «змейка», шведской стенки и перекладин разной высоты. Позволяет выполнять подтягивания, упражнения в висе и передвижение с перехватами рук.',
    photos: ['/equipment/smart-playground/08. Комплекс из рук-зм., шв. ст., 5 турн. кл. хв.webp'],
    videoUrl: 'https://rutube.ru/play/embed/c3eb29d448259f767ac479a8ca640d9a',
    videoTitle: 'Подтягивания на перекладинах',
    specs: [
      { label: 'Габариты', value: '5 000 × 800 × 2 500 мм' },
      { label: 'Турники', value: '5 шт., классический хват' },
      { label: 'Шведская стенка', value: '1 секция, 12 перекладин' },
      { label: 'Рукоход', value: 'Змейкой, 8 перекладин' },
      { label: 'Материал', value: 'Ст3, порошковое окрашивание' },
      { label: 'Гарантия', value: '5 лет' },
    ],
    exercises: [
      {
        title: 'Подтягивание на перекладине',
        inVideo: true,
        start:
          'Выберите перекладину, на которой можете свободно висеть, и возьмитесь за неё хватом сверху.',
        steps: [
          'Подтянитесь без раскачивания до положения подбородка выше перекладины.',
          'Медленно опуститесь до выпрямления рук.',
        ],
        tips: ['Не опирайтесь ногами на соседние элементы во время повторения.'],
      },
      {
        title: 'Подъём согнутых ног в висе',
        start: 'Примите вис на высокой перекладине. Удерживайте плечи и корпус, ноги сведены.',
        steps: [
          'Плавно согните ноги и подтяните колени к корпусу.',
          'Опустите ноги в исходное положение без маха.',
        ],
        tips: ['Начинайте новое повторение после остановки раскачивания.'],
      },
      {
        title: 'Передвижение по рукоходу «змейка»',
        start: 'Возьмитесь за начало рукохода обеими руками и примите вис.',
        steps: [
          'Перехватитесь одной рукой за следующий участок рукохода.',
          'Следуйте изгибам рукохода, поочерёдно перенося руки.',
          'Остановитесь и плавно сойдите на покрытие.',
        ],
        tips: [
          'Держите свободным участок под собой и не проходите навстречу другому занимающемуся.',
        ],
      },
    ],
    safetyNote:
      'Выбирайте один свободный участок комплекса. Не используйте шведскую стенку как опору для прыжка на соседний снаряд.',
  },
  {
    id: 'sp-09',
    categorySlug: 'smart-playground',
    number: '09',
    title: 'Лавка с упорами',
    description:
      'Низкая металлическая конструкция с рядом приподнятых упоров для кистей. Используется для отжиманий с ногами на покрытии и смены положения рук между подходами.',
    photos: ['/equipment/smart-playground/09. Лавка с упорами.webp'],
    videoUrl: 'https://rutube.ru/play/embed/dcdbe3b8926a30d7e1c52c3c48bcc74f',
    videoTitle: 'Отжимания с хватом за упоры',
    specs: [
      { label: 'Длина', value: '1 400 мм' },
      { label: 'Высота', value: '450 мм' },
      { label: 'Диаметр трубы', value: '48 мм' },
      { label: 'Материал', value: 'Ст3, порошковое окрашивание' },
      { label: 'Макс. нагрузка', value: '200 кг' },
      { label: 'Гарантия', value: '5 лет' },
    ],
    exercises: [
      {
        title: 'Отжимания с хватом за упоры',
        inVideo: true,
        start:
          'Возьмитесь за два упора, поставьте стопы на покрытие и выпрямите корпус. Кисти остаются на рукоятях, ноги — на одной линии с корпусом.',
        steps: [
          'Согните руки и плавно опустите грудь между упорами.',
          'Оттолкнитесь руками и вернитесь в исходное положение.',
        ],
        tips: [
          'Не опускайтесь глубже, чем можете контролировать.',
          'Меняйте выбранные упоры после завершения подхода.',
        ],
      },
    ],
    safetyNote:
      'Проверьте сухость рукоятей и устойчивость стоп. Не вставайте ногами на узкие верхние упоры.',
  },
  {
    id: 'sp-10',
    categorySlug: 'smart-playground',
    number: '10',
    title: 'Многофункциональный комплекс',
    description:
      'Гимнастический комплекс с перекладинами, шведской стенкой, кольцами и скамьями. Используется для подтягиваний, подъёма туловища на наклонной скамье и упражнений на пресс сидя.',
    photos: ['/equipment/smart-playground/10. Многофункциональный комплекс.webp'],
    videoUrl: 'https://rutube.ru/play/embed/1dda04d2896a691f5f85bc3de13ef68a',
    videoTitle: 'Упражнения на пресс и подтягивания',
    specs: [
      { label: 'Габариты', value: '4 000 × 2 000 × 2 800 мм' },
      { label: 'Тренировочных станций', value: '6 шт.' },
      { label: 'Материал', value: 'Ст3, труба 60 мм' },
      { label: 'Покрытие', value: 'Порошковое, антивандальное' },
      { label: 'Макс. нагрузка', value: '300 кг' },
      { label: 'Гарантия', value: '5 лет' },
    ],
    exercises: [
      {
        title: 'Подъём туловища на наклонной скамье',
        inVideo: true,
        start:
          'Сядьте на скамью, закрепите стопы в штатном упоре и плавно лягте на спину. Руки скрещены на груди.',
        steps: [
          'Поднимите туловище усилием мышц живота.',
          'Плавно вернитесь на скамью, сохраняя контроль движения.',
        ],
        tips: ['Не тяните голову руками и не бросайте спину на опору.'],
      },
      {
        title: 'Подтягивание коленей к корпусу сидя на скамье',
        inVideo: true,
        start:
          'Сядьте на горизонтальную скамью, немного отклоните корпус назад и приподнимите стопы над покрытием. Для устойчивости держитесь руками за края скамьи.',
        steps: [
          'Согните ноги и плавно подтяните колени к корпусу.',
          'Отведите ноги вперёд, сохраняя равновесие и не опуская стопы на покрытие.',
        ],
        tips: [
          'Работайте в небольшой амплитуде без раскачивания корпуса.',
          'Не округляйте поясницу.',
        ],
      },
      {
        title: 'Подтягивание на перекладине',
        inVideo: true,
        start: 'Возьмитесь за перекладину хватом сверху и примите вис на прямых руках.',
        steps: [
          'Подтянитесь до положения подбородка выше перекладины.',
          'Медленно опуститесь до выпрямления рук.',
        ],
        tips: ['Завершайте повторение без раскачивания и прыжка на покрытие.'],
      },
    ],
    safetyNote:
      'Переходите между снарядами после полной остановки. Оставляйте свободными зоны под перекладинами и кольцами.',
  },
  {
    id: 'sp-11',
    categorySlug: 'smart-playground',
    number: '11',
    title: 'Игровая площадка с ограждением',
    description:
      'Ограждённое игровое поле с баскетбольными щитами и воротами в торцах. На изображении показана баскетбольная разметка и оборудование для игр в баскетбол и мини-футбол.',
    photos: ['/equipment/smart-playground/11. Ограждение.webp'],
    specs: [
      {
        label: 'Длина секции ограждения',
        value: '2 000 мм',
      },
    ],
    composition: [
      {
        title: 'Баскетбольная зона',
        description:
          'Щиты с кольцами расположены на противоположных торцах поля. На покрытии показаны центральный круг, зоны под щитами и линии для игры в баскетбол.',
      },
      {
        title: 'Ворота для мини-футбола',
        description:
          'Под баскетбольными щитами размещены ворота. Игровое поле можно использовать для тренировок с мячом и игр в мини-футбол.',
      },
      {
        title: 'Секционное ограждение',
        description:
          'Металлические панели на стойках проходят по периметру поля и отделяют игровую зону от соседнего оборудования и проходов.',
      },
      {
        title: 'Входы на поле',
        description:
          'В ограждении предусмотрены открывающиеся входные секции для доступа на площадку.',
      },
    ],
  },
  {
    id: 'sp-12',
    categorySlug: 'smart-playground',
    number: '12',
    title: 'Скамья',
    description:
      'Горизонтальная скамья на уличных опорах. Используется как опора для отжиманий, в том числе с положением рук за спиной; вне тренировки — для отдыха между подходами.',
    photos: ['/equipment/smart-playground/12. Скамья.webp'],
    videoUrl: 'https://rutube.ru/play/embed/0bbf8b248ac873941f81ba95cd6e0d80',
    videoTitle: 'Обратные отжимания от скамьи',
    specs: [
      { label: 'Длина', value: '1 800 мм' },
      { label: 'Высота', value: '450 мм' },
      { label: 'Планки', value: 'Сталь 40×20 мм' },
      { label: 'Покрытие', value: 'Порошковое' },
      { label: 'Макс. нагрузка', value: '300 кг' },
      { label: 'Гарантия', value: '5 лет' },
    ],
    exercises: [
      {
        title: 'Сгибание и разгибание рук в упоре сзади о скамью',
        inVideo: true,
        start:
          'Сядьте на край скамьи и поставьте ладони рядом с тазом. Сместите таз вперёд с края, стопы устойчиво стоят на покрытии.',
        steps: [
          'Плавно согните руки и опустите таз рядом со скамьёй, сохраняя спину близко к её краю.',
          'Выпрямите руки и вернитесь в исходное положение.',
        ],
        tips: ['Начните с согнутых ног и небольшой глубины.', 'Не поднимайте плечи к ушам.'],
      },
      {
        title: 'Отжимания от края скамьи',
        start:
          'Встаньте лицом к скамье, упритесь ладонями в её край и отведите стопы назад. Корпус и ноги — на одной линии.',
        steps: [
          'Согните руки, приближая грудь к краю скамьи.',
          'Плавно выпрямите руки и вернитесь в исходное положение.',
        ],
        tips: ['Не опускайте таз и не прогибайтесь в пояснице.'],
      },
    ],
    safetyNote:
      'Не выполняйте упражнения на мокрой или обледенелой скамье. Прекратите движение при дискомфорте в плечах.',
  },
  {
    id: 'sp-13',
    categorySlug: 'smart-playground',
    number: '13',
    title: 'Тройной каскад турников',
    description:
      'Три перекладины на разной высоте, соединённые общими опорами. Низкая перекладина служит опорой для отжиманий, высокая — для подтягиваний и упражнений в висе.',
    photos: ['/equipment/smart-playground/13. Тройной каскад турников.webp'],
    videoUrl: 'https://rutube.ru/play/embed/1d6c7220b2723d245c20dfe43e97fb94',
    videoTitle: 'Отжимания от низкой перекладины',
    specs: [
      { label: 'Высота перекладин', value: '1 800 / 2 100 / 2 400 мм' },
      { label: 'Диаметр перекладины', value: '34 мм' },
      { label: 'Стойки', value: 'Труба 76 мм, Ст3' },
      { label: 'Макс. нагрузка', value: '200 кг на перекладину' },
      { label: 'Гарантия', value: '5 лет' },
    ],
    exercises: [
      {
        title: 'Отжимания от низкой перекладины',
        inVideo: true,
        start:
          'Упритесь ладонями в низкую перекладину и отведите ноги назад. Удерживайте прямую линию от плеч до стоп.',
        steps: [
          'Согните руки и приблизьте грудь к перекладине.',
          'Плавно выпрямите руки, сохраняя положение корпуса.',
        ],
        tips: [
          'Для начала выберите более высокую опору, если на ней проще контролировать движение.',
        ],
      },
      {
        title: 'Подтягивание на высокой перекладине',
        start: 'Возьмитесь за высокую перекладину хватом сверху и примите вис.',
        steps: [
          'Подтянитесь без маха ногами, пока подбородок не окажется выше перекладины.',
          'Медленно опуститесь до выпрямления рук.',
        ],
        tips: ['Плечи и шея остаются свободными, без резкого запрокидывания головы.'],
      },
    ],
    safetyNote:
      'Выбирайте перекладину, на которой можете занять исходное положение и сойти без прыжка. Не занимайтесь одновременно вплотную к соседнему пользователю.',
  },
  {
    id: 'sp-14',
    categorySlug: 'smart-playground',
    number: '14',
    title: 'Стойка баскетбольная',
    description:
      'Уличная стойка со щитом, кольцом и сеткой для занятий баскетболом. Используется для отработки бросков и игровых упражнений с мячом на подготовленной площадке.',
    photos: ['/equipment/smart-playground/14. Стойка баскетбольная.webp'],
    specs: [
      { label: 'Высота стойки', value: '3 200 мм' },
      { label: 'Вынос щита', value: '1 200 мм' },
      { label: 'Щит', value: '1 800 × 1 050 мм' },
      { label: 'Кольцо', value: 'Ø 450 мм, с сеткой' },
      { label: 'Материал', value: 'Ст3, профильная труба' },
      { label: 'Покрытие', value: 'Порошковое, антивандальное' },
      { label: 'Гарантия', value: '5 лет' },
    ],
    exercises: [
      {
        title: 'Броски мяча в кольцо с места',
        start:
          'Встаньте лицом к щиту на удобном расстоянии. Стопы устойчивы, колени слегка согнуты; удерживайте мяч перед собой.',
        steps: [
          'Поднимите мяч к уровню головы: бросающая рука под мячом, вторая поддерживает его сбоку.',
          'Разгибая ноги и бросающую руку, направьте мяч в кольцо движением кисти.',
          'После броска опустите руки и дождитесь свободного места для подбора мяча.',
        ],
        tips: [
          'Начните с близкого расстояния и спокойного темпа.',
          'Сохраняйте положение стоп во время броска с места.',
        ],
      },
    ],
    safetyNote:
      'Не висите на кольце и не взбирайтесь на стойку. Подбирайте мяч, когда зона под щитом свободна.',
  },
];
